var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcvbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 3.71875H6.375C5.52962 3.71875 4.71887 4.05458 4.1211 4.65235C3.52333 5.25012 3.1875 6.06087 3.1875 6.90625V27.0938C3.1875 27.9391 3.52333 28.7499 4.1211 29.3477C4.71887 29.9454 5.52962 30.2812 6.375 30.2812H27.625C28.4704 30.2812 29.2811 29.9454 29.8789 29.3477C30.4767 28.7499 30.8125 27.9391 30.8125 27.0938V6.90625C30.8125 6.06087 30.4767 5.25012 29.8789 4.65235C29.2811 4.05458 28.4704 3.71875 27.625 3.71875Z",
    fill: "#ffc466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 6.90625V27.0938C30.8125 27.9391 30.4767 28.7499 29.8789 29.3477C29.2811 29.9454 28.4704 30.2812 27.625 30.2812H16.4688V3.71875H27.625C28.4704 3.71875 29.2811 4.05458 29.8789 4.65235C30.4767 5.25012 30.8125 6.06087 30.8125 6.90625Z",
    fill: "#ffc466"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.969 14.3437C24.969 14.6255 24.8571 14.8958 24.6578 15.095C24.4586 15.2943 24.1883 15.4062 23.9065 15.4062H9.56276C9.35269 15.4067 9.14721 15.3448 8.97228 15.2285C8.79735 15.1122 8.66082 14.9467 8.57994 14.7528C8.4999 14.5583 8.47939 14.3444 8.521 14.1382C8.56261 13.9321 8.66448 13.7429 8.81369 13.5947L12.0012 10.4072C12.2045 10.2331 12.4659 10.1421 12.7333 10.1525C13.0007 10.1628 13.2544 10.2736 13.4436 10.4629C13.6328 10.6521 13.7437 10.9058 13.754 11.1732C13.7643 11.4406 13.6734 11.702 13.4993 11.9053L12.1287 13.2812H23.9065C24.1883 13.2812 24.4586 13.3932 24.6578 13.5924C24.8571 13.7917 24.969 14.0619 24.969 14.3437Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7178 20.9366L22.5303 24.1241C22.3271 24.2981 22.0656 24.3891 21.7982 24.3788C21.5308 24.3684 21.2771 24.2576 21.0879 24.0684C20.8987 23.8791 20.7878 23.6255 20.7775 23.3581C20.7672 23.0907 20.8581 22.8292 21.0322 22.6259L22.4028 21.25H10.625C10.3432 21.25 10.073 21.1381 9.8737 20.9388C9.67444 20.7395 9.5625 20.4693 9.5625 20.1875C9.5625 19.9057 9.67444 19.6355 9.8737 19.4362C10.073 19.2369 10.3432 19.125 10.625 19.125H24.9688C25.1788 19.1246 25.3843 19.1864 25.5592 19.3027C25.7342 19.419 25.8707 19.5846 25.9516 19.7784C26.0316 19.9729 26.0521 20.1868 26.0105 20.393C25.9689 20.5992 25.867 20.7883 25.7178 20.9366Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 14.3438C24.9688 14.062 24.8568 13.7917 24.6576 13.5924C24.4583 13.3932 24.188 13.2812 23.9062 13.2812H16.4688V15.4062H23.9062C24.188 15.4062 24.4583 15.2943 24.6576 15.0951C24.8568 14.8958 24.9688 14.6255 24.9688 14.3438Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9516 19.7784C25.8707 19.5846 25.7342 19.419 25.5592 19.3027C25.3843 19.1864 25.1788 19.1246 24.9688 19.125H16.4688V21.25H22.4028L21.0322 22.6259C20.921 22.7212 20.8306 22.8384 20.7669 22.9702C20.7031 23.102 20.6672 23.2456 20.6616 23.3919C20.6559 23.5383 20.6806 23.6842 20.734 23.8205C20.7874 23.9569 20.8685 24.0807 20.972 24.1843C21.0755 24.2878 21.1994 24.3688 21.3357 24.4222C21.4721 24.4757 21.618 24.5003 21.7643 24.4947C21.9106 24.489 22.0542 24.4532 22.186 24.3894C22.3178 24.3256 22.4351 24.2353 22.5303 24.1241L25.7178 20.9366C25.867 20.7883 25.9689 20.5992 26.0105 20.393C26.0521 20.1868 26.0316 19.9729 25.9516 19.7784Z",
    fill: "fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_372",
    x1: 30.6797,
    y1: 17,
    x2: 16.4581,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25D7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25B8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_328_372",
    x1: 24.8891,
    y1: 14.3438,
    x2: 16.4634,
    y2: 14.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B39C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_328_372",
    x1: 25.9463,
    y1: 21.7813,
    x2: 16.4634,
    y2: 21.7813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B39C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcvbl);
export default __webpack_public_path__ + "static/media/rcvbl.4b56eab5b6f25cbd6ca4060136baa267.svg";
export { ForwardRef as ReactComponent };